import type { Domain } from "./types";
import { getNewVsReturning } from "./getNewVsReturning";

type NewVsReturningAverage = {
    newUsersAverage: number;
    returningUsersAverage: number;
};

export const getNewVsReturningAverage = async (domain?: Domain): Promise<NewVsReturningAverage> => {
    if (!domain) {
        return { newUsersAverage: 0, returningUsersAverage: 0 };
    }

    const newVsReturning = await getNewVsReturning();
    const domainData = newVsReturning[domain];
    const { Graph: graph } = domainData;
    const dataPoints = Object.values(graph);
    const dataPointsCount = dataPoints.length;
    const newVsReturningAverage = dataPoints.reduce<NewVsReturningAverage>(
        (acc, dataPoint) => {
            const { NewUsers: newUsers, ReturningUsers: returningUsers } = dataPoint;
            const { newUsersAverage = 0, returningUsersAverage = 0 } = acc;
            return {
                newUsersAverage: newUsersAverage + newUsers / dataPointsCount,
                returningUsersAverage: returningUsersAverage + returningUsers / dataPointsCount,
            };
        },
        {
            newUsersAverage: 0,
            returningUsersAverage: 0,
        },
    );
    return newVsReturningAverage;
};
